// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brief-delete-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid #e0e6ef;
  border-radius: 8px;
  background: #f8fafc;
  color: #69778e;
  cursor: pointer;
  transition: background 150ms, color 150ms, border-color 150ms;
}
.brief-delete-button svg {
  width: 14px;
  height: 14px;
}
.brief-version-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
}
.brief-delete-button:hover {
  color: #334b72;
  border-color: #bbcbe0;
  background: #edf2fa;
}
.brief-delete-button:focus-visible,
.brief-delete-all:focus-visible,
.brief-delete-dialog button:focus-visible {
  outline: 2px solid #3159ee;
  outline-offset: 3px;
}
.brief-delete-button:disabled,
.brief-delete-all:disabled,
.brief-delete-dialog button:disabled {
  opacity: .55;
  cursor: wait;
}
.brief-delete-all {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 8px;
  width: 100px;
  padding: 16px 10px;
  border: 1px solid #dfe6f2;
  border-radius: 16px;
  background: #fff;
  color: #526079;
  box-shadow: 0 1px 3px #24375c0d;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms, border-color 150ms;
}
.brief-delete-all:hover:not(:disabled) {
  border-color: #bbcbe0;
  background: #f8faff;
}
.brief-delete-all-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #f1f4f9;
  color: #69778e;
}
.brief-delete-all-caption {
  margin-top: -4px;
  font-size: 10px;
  font-weight: 400;
  color: #858c9c;
}
@media (max-width: 479px) {
  .brief-delete-all {
    width: 72px;
    padding: 12px 6px;
  }
}
.brief-delete-dialog {
  width: min(490px, calc(100vw - 32px));
  max-height: calc(100dvh - 40px);
  margin: auto;
  padding: 28px;
  overflow-y: auto;
  border: 1px solid #e0e6ef;
  border-radius: 22px;
  background: #fff;
  color: #263247;
  box-shadow: 0 24px 80px #172b4d33;
}
.brief-delete-dialog::backdrop {
  background: #17233866;
  backdrop-filter: blur(4px);
}
.brief-delete-dialog-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 18px;
  border-radius: 14px;
  background: #eef2f8;
  color: #556984;
}
.brief-delete-dialog-symbol svg { width: 23px; height: 23px; }
.brief-delete-dialog h2 { margin: 0 0 14px; font-size: 21px; font-weight: 700; line-height: 1.3; }
.brief-delete-dialog p { margin: 10px 0; font-size: 14px; line-height: 1.65; color: #68758b; overflow-wrap: anywhere; }
.brief-delete-dialog strong { color: #334155; }
.brief-delete-dialog .brief-delete-error { padding: 12px; border-radius: 10px; background: #f0f3f8; color: #334b72; }
.brief-delete-dialog-actions { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 10px; margin-top: 24px; }
.brief-delete-dialog button { padding: 10px 14px; border: 1px solid #dfe5ef; border-radius: 10px; background: #fff; color: #52617a; font-size: 13px; font-weight: 600; cursor: pointer; }
.brief-delete-dialog .brief-delete-confirm { background: #334b72; border-color: #334b72; color: #fff; }
@media (prefers-reduced-motion: reduce) {
  .brief-delete-button,
  .brief-delete-all { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/site-brief-delete.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;;;EAGE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;AACA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;AACA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;AACA,kCAAkC,WAAW,EAAE,YAAY,EAAE;AAC7D,0BAA0B,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACjG,yBAAyB,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,uBAAuB,EAAE;AACtH,8BAA8B,cAAc,EAAE;AAC9C,2CAA2C,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACpH,+BAA+B,aAAa,EAAE,yBAAyB,EAAE,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACvH,8BAA8B,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AACxL,6CAA6C,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AACtG;EACE;sBACoB,gBAAgB,EAAE;AACxC","sourcesContent":[".brief-delete-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid #e0e6ef;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #69778e;\n  cursor: pointer;\n  transition: background 150ms, color 150ms, border-color 150ms;\n}\n.brief-delete-button svg {\n  width: 14px;\n  height: 14px;\n}\n.brief-version-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 24px;\n  padding: 0 6px;\n}\n.brief-delete-button:hover {\n  color: #334b72;\n  border-color: #bbcbe0;\n  background: #edf2fa;\n}\n.brief-delete-button:focus-visible,\n.brief-delete-all:focus-visible,\n.brief-delete-dialog button:focus-visible {\n  outline: 2px solid #3159ee;\n  outline-offset: 3px;\n}\n.brief-delete-button:disabled,\n.brief-delete-all:disabled,\n.brief-delete-dialog button:disabled {\n  opacity: .55;\n  cursor: wait;\n}\n.brief-delete-all {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  gap: 8px;\n  width: 100px;\n  padding: 16px 10px;\n  border: 1px solid #dfe6f2;\n  border-radius: 16px;\n  background: #fff;\n  color: #526079;\n  box-shadow: 0 1px 3px #24375c0d;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms;\n}\n.brief-delete-all:hover:not(:disabled) {\n  border-color: #bbcbe0;\n  background: #f8faff;\n}\n.brief-delete-all-symbol {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  background: #f1f4f9;\n  color: #69778e;\n}\n.brief-delete-all-caption {\n  margin-top: -4px;\n  font-size: 10px;\n  font-weight: 400;\n  color: #858c9c;\n}\n@media (max-width: 479px) {\n  .brief-delete-all {\n    width: 72px;\n    padding: 12px 6px;\n  }\n}\n.brief-delete-dialog {\n  width: min(490px, calc(100vw - 32px));\n  max-height: calc(100dvh - 40px);\n  margin: auto;\n  padding: 28px;\n  overflow-y: auto;\n  border: 1px solid #e0e6ef;\n  border-radius: 22px;\n  background: #fff;\n  color: #263247;\n  box-shadow: 0 24px 80px #172b4d33;\n}\n.brief-delete-dialog::backdrop {\n  background: #17233866;\n  backdrop-filter: blur(4px);\n}\n.brief-delete-dialog-symbol {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 18px;\n  border-radius: 14px;\n  background: #eef2f8;\n  color: #556984;\n}\n.brief-delete-dialog-symbol svg { width: 23px; height: 23px; }\n.brief-delete-dialog h2 { margin: 0 0 14px; font-size: 21px; font-weight: 700; line-height: 1.3; }\n.brief-delete-dialog p { margin: 10px 0; font-size: 14px; line-height: 1.65; color: #68758b; overflow-wrap: anywhere; }\n.brief-delete-dialog strong { color: #334155; }\n.brief-delete-dialog .brief-delete-error { padding: 12px; border-radius: 10px; background: #f0f3f8; color: #334b72; }\n.brief-delete-dialog-actions { display: flex; justify-content: flex-end; flex-wrap: wrap; gap: 10px; margin-top: 24px; }\n.brief-delete-dialog button { padding: 10px 14px; border: 1px solid #dfe5ef; border-radius: 10px; background: #fff; color: #52617a; font-size: 13px; font-weight: 600; cursor: pointer; }\n.brief-delete-dialog .brief-delete-confirm { background: #334b72; border-color: #334b72; color: #fff; }\n@media (prefers-reduced-motion: reduce) {\n  .brief-delete-button,\n  .brief-delete-all { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
